import { getApi, postApi, getApiErrorMypage } from "../utils/common";

// パスワードをお忘れの方-メール送信
export const postSendMail = async (data) => {
  const urlPath = "/api/mypage/login/sendmail/";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, postData);
  }
};

// パスワード再設定-初期表示
export const getIsExpire = async (searchCondition) => {
  const urlPath = "/api/mypage/login/isexpire/?";
  const searchParams = new URLSearchParams({ ...searchCondition });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, searchParams);
  }
};

// パスワード再設定
export const postPasswordSetting = async (data) => {
  const urlPath = "/api/mypage/login/passwordsetting/";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, postData);
  }
};
